<template>
  <div class="mt-2 lancar-conceito">
    <div>
      <v-btn icon :to="{ name: 'diario-escolar', params: { paginaAtualTurmas }}">
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </div>

    <Select
      v-if="periodosAvaliativos.length > 0"
      class="mt-4 lancar-conceito-header-select"
      label="Período Avaliativo"
      v-model="periodoSelecionado"
      :disabled="loading"
      :options="periodosAvaliativos"
      @change="changePeriodoAvaliativo"
    />

    <transition
      name="router-lancar-conceito-input"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <SelectCustomRows
        v-if="atividadesDistribuidas.length > 0"
        class="mt-5 mb-3 lancar-conceito-atividade-select"
        label="Atividade Avaliativa"
        v-model="distribuicaoSelecionada"
        :disabled="loading"
        :options="atividadesDistribuidas"
        @change="changeAtividade"
      />
    </transition>

    <div class="mb-2">
      <v-btn
        type="button"
        :loading="loadingSaveConceitos"
        :disabled="loadingSaveConceitos || !getExisteConceitosPendenteParaSalvar(conceitos)"
        small
        color="teal"
        class="teste rounded-sm"
        @click="handleSaveConceitos"
      >
        <v-icon color="#FFF" v-if="getExisteConceitosPendenteParaSalvar(conceitos)" small>error</v-icon>
        <v-icon color="#FFF" v-if="!getExisteConceitosPendenteParaSalvar(conceitos)" small>done</v-icon>
       <span class="white--text font-weight-regular ms-2">Salvar Conceitos</span>
      </v-btn>
    </div>

    <div v-if="exibirMsgError">
      <v-alert type="error" value="true" style="color: white;">
        <div v-if="periodosAvaliativos.length <= 0">Nenhum período avaliativo encontrado!</div>
        <div v-if="msgError">{{ msgError }}</div>
      </v-alert>
    </div>

    <transition
      name="router-lancar-conceito"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div v-if="!exibirMsgError && enturmacaoConceito.length > 0" class="table-overflow">
        <table class="table-siged" style="position: relative">
          <thead class="fixed">
            <tr>
              <th>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }" >
                    <v-icon v-bind="attrs" v-on="on" size="20" >notification_important</v-icon>
                  </template>
                  <span class="text-caption white--text">Dê um duplo clique no nome do aluno abaixo para visualizar <br>informações de contato sobre o respectivo aluno.</span>
                </v-tooltip>
                Aluno
              </th>
              <th>
                <v-tooltip bottom style="flex: 1">
                  <template v-slot:activator="{ on, attrs }">
                    <div>
                      Conceito
                      <v-icon v-bind="attrs" v-on="on" size="20" style="vertical-align: top">notification_important</v-icon>
                    </div>
                  </template>

                  <span class="text-caption white--text">
                    <div v-for="key in tiposConceitos" :key="key.id">
                      <i>
                        <strong>{{ key.valorconceito }}</strong>
                        - {{ key.descricaoconceito }}
                      </i>
                    </div>
                  </span>
                </v-tooltip>
              </th>
              <th>CONCEITO PERÍODO</th>
              <th>CONCEITO GERAL DOS PERÍODOS AVALIATIVOS</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(aluno, index) in enturmacaoConceito" :key="aluno.id">
              <td style="cursor: pointer;" @dblclick="dadosContatoAluno = {dialog: true, cdtipesc: aluno.cdtipesc, cdescola: aluno.cdescola, numatalun: aluno.numatalun};">
                <div v-if="aluno.situacao_fim !== null" style="background-color:skyblue;">{{ aluno.nmaluno}}
                  <span style="font-weight:bold;" v-if="(/PDI/.test(aluno.invalido)  && pdirecebelancamento == 'S')">- PDI</span>
                  <span style="font-weight:bold;" v-if="(/DISPENSADO/.test(aluno.invalido))">- DISPENSADO</span>
                </div>
                <div v-else>{{ aluno.nmaluno}}
                  <span style="font-weight:bold;" v-if="(/PDI/.test(aluno.invalido)  && pdirecebelancamento == 'S')">- PDI</span>
                  <span style="font-weight:bold;" v-if="(/DISPENSADO/.test(aluno.invalido))">- DISPENSADO</span>
                </div>

                <div style="font-size: 10px">
                  <i>
                    <strong>Dt. Enturmação:</strong>
                    {{ aluno.dtsitalun | formatDataBR }}
                  </i>
                  <!-- Henrique <i v-if="aluno.possuiTolerancia" style="margin-left: 10px"><strong>{{ aluno.invalido }}:</strong> {{ aluno.dtafastam | formatDataBR }}</i> -->
                  <i v-if="aluno.situacao_fim !== null" style="margin-left: 10px; background-color: gold;">
                    <strong>{{ aluno.invalido }}:</strong>
                    {{ aluno.dtafastam | formatDataBR }}
                  </i>
                </div>
              </td>
              <td class="centro tamanho-colunas">
                <!-- Henrique <span v-if="aluno.invalido !== null && !aluno.possuiTolerancia" class="centro"> -->
                <span v-if="(/PDI/.test(aluno.invalido) && pdirecebelancamento != 'S')" class="centro">
                  {{ aluno.invalido }}
                  <span
                    v-if="aluno.dtafastam !== null"
                  >- {{ aluno.dtafastam | formatDataBR }}</span>
                </span>
                <span v-if="(/DISPENSADO/.test(aluno.invalido))" class="centro">
                  DISPENSADO
                  <span
                    v-if="aluno.dtafastam !== null"
                  >- {{ aluno.dtafastam | formatDataBR }}</span>
                </span>
                <SelectLancarConceito
                  v-else
                  v-bind="montarFormSubmit"
                  class="select-conceito"
                  :data-index="index"
                  :index="index"
                  :disabled="!periodoAberto"
                  :optionsConceito="montarOptionsConceitos"
                  :numatalun="aluno.numatalun"
                  @click.native="event => onClickInput(event, index)"
                  @submitted="onSubmittedSelect"
                  v-model="aluno.distribuir_conceito.identificadorconceito"
                  @nota="onAddNotaNaLista"
                  :showErros="getErros(index, listaErros)"
                />
              </td>
              <td class="centro destaque-coluna tamanho-colunas">{{ totalPeriodo(index) }}</td>
              <td class="centro destaque-coluna tamanho-colunas">{{ totalTodosPeriodos(index) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </transition>

    <template>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="600">
          <v-card>
            <v-card-title class="headline">Atenção</v-card-title>
            <v-card-text>Olá, identificamos que existem alterações nos conceitos que devem ser salvos. Você confirma essas alterações ?</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div >
                <v-row class="d-flex flex-wrap justify-center pa-2">
                  <v-col class="pa-1 flex-grow-1 " >
                      <v-btn
                        class="rounded-sm font-weight-regular text-capitalize flex-grow-1"
                        color
                        @click="handleCancelModalAvisoConceitos()"
                      >Descartar alterações</v-btn>

                  </v-col>
                  <v-col class="pa-1"  >
                    <v-btn
                      class="rounded-sm font-weight-regular custom-transform-class text-none white--text"
                      color="teal"
                      :loading="loadingSaveConceitos"
                      :disabled="loadingSaveConceitos"
                      @click="handleModalSaveConceitos()"
                    >Ok, confirmo o lançamento dos conceitos</v-btn>

                  </v-col>

                </v-row>
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>

    <ContatoAluno v-bind.sync="dadosContatoAluno" />
  </div>
</template>

<script>
import store from "@/store/index";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import SelectLancarConceito from "@/components/SelectLancarConceito";
import SelectCustomRows from "@/components/SelectCustomRows";
import ContatoAluno from '@/components/ContatoAluno';

const DiarioEscolarRepository = RepositoryFactory.get("diarioEscolar");
const PeriodoAvaliativoRepository = RepositoryFactory.get("periodoAvaliativo");

const dadosUser = () => ({
  ...store.getters.userProfessor,
  ...store.getters.school,
});

const buscarEnturmacao = async (dados) => {
  return await DiarioEscolarRepository.getEnturmacaoConceito({
    ...dados,
    ...dadosUser(),
  });
};

const buscarAtividades = async (dados) => {
  const atividadesQualitativa = await DiarioEscolarRepository.getAtividadeQualitativaTurma(
    {
      ...dados,
      ...dadosUser(),
    }
  );

  return atividadesQualitativa.data.results.map((key) => ({
    value: key.identificadordistribuirconceit,
    text:
      key.descricaoatividadeavaliativa.length < 120
        ? key.descricaoatividadeavaliativa
        : `${key.descricaoatividadeavaliativa.substring(0, 120)} ...`,
    title: key.descricaoatividadeavaliativa,
    icon: key.vinculo ? "check" : "remove",
  }));
};

const saveListaConceitosConceito = async (conceitos) => {
  return await DiarioEscolarRepository.saveListaConceitosConceito(conceitos);
};

export default {
  name: "LancarConceito",
  components: {
    SelectLancarConceito,
    SelectCustomRows,
    ContatoAluno,
  },
  props: {
    ano: [String, Number],
    cdturma: [String, Number],
    disciplina: [String, Number],
    paginaAtualTurmas: [String, Number],
    tipoDeEnsino: [String],
    cdinstruc: [Number],
  },
  data() {
    return {
      submitText: "",
      snackbar: false,
      dialog: false,
      listaErros: [],
      conceitos: [],
      loadingSaveConceitos: false,
      loading: false,
      router_leave: null,
      retornarParaATelaInicial: false,
      isReload: true,
      periodoSelecionadoOld: "",
      periodoSelecionado: "",
      periodosAvaliativos: [],
      atividadesDistribuidas: [],
      distribuicaoSelecionadaOld: "",
      distribuicaoSelecionada: "",
      enturmacaoConceito: [],
      msgError: "",
      tiposConceitos: [],
      periodoAberto: false,
      linhaX: 0,
      linhaY: 0,
      todasAtividadesAlunos: [],
      aaletivo: this.ano,
      codinstruc: this.cdinstruc,
      pdirecebelancamento: '',
      dadosContatoAluno: {},
    };
  },
  async beforeRouteEnter(to, from, next) {
    if (
      typeof to.params.ano === "undefined" ||
      typeof to.params.cdturma === "undefined" ||
      typeof to.params.disciplina === "undefined"
    ) {
      return next("/diario-escolar");
    }
    try {
      const { cdtipesc, cdescola } = dadosUser();
      const dadosTurma = {
        aaletivo: to.params.ano,
        cdtipesc,
        cdescola,
        cdturma: to.params.cdturma,
        cdinstruc: to.params.cdinstruc,
      };

      const periodo = await PeriodoAvaliativoRepository.getPeriodoTurmas(
        dadosTurma
      );
      const formatedPeriodo = periodo.data.results.map((key) => ({
        value: key.cdpravadi,
        text: key.dspravadi,
      }));

      let formatedAtividade = [];
      if (formatedPeriodo.length > 0) {
        formatedAtividade = await buscarAtividades({
          aaletivo: to.params.ano,
          cdturma: to.params.cdturma,
          cddiscipl: to.params.disciplina,
          cdpravadi: formatedPeriodo[0].value,
        });
      }

      next((vm) => {
        vm.montarPeriodoAvaliativo(formatedPeriodo);
      });
    } catch (e) {
      return next("/diario-escolar");
    }
  },
  beforeRouteLeave: function (to, from, next) {
    if (sessionStorage.httpStatusCode) {
      next();
    }
    const existeConceitosParaSalvar = this.getExisteConceitosPendenteParaSalvar(
      this.conceitos
    );

    if (existeConceitosParaSalvar) {
      this.dialog = true;

      if (from.fullPath !== to.fullPath) {
        this.router_leave = to.fullPath;
      }

      next(false);
    } else {
      this.dialog = false;
      next();
    }
  },
  watch: {
    periodoSelecionado: {
      handler: function (newVal, oldVal) {
        if (this.dialog) {
          if (oldVal !== null && oldVal != "") {
            this.periodoSelecionadoOld = String(oldVal);
          }
        } else {
          this.periodoSelecionadoOld = this.periodoSelecionado;
        }
      },
    },
    distribuicaoSelecionada: {
      handler: function (newVal, oldVal) {
        if (this.dialog) {
          if (oldVal !== null && oldVal != "") {
            this.distribuicaoSelecionadaOld = oldVal;
          }
        } else {
          this.distribuicaoSelecionadaOld = this.distribuicaoSelecionada;
        }
      },
    },
  },
  created() {
    document.addEventListener("keyup", this.onKeyUp);
  },
  destroyed() {
    document.removeEventListener("keyup", this.onKeyUp);
  },
  methods: {
    getErros(index, listaErros) {
      let error = [];
      if (listaErros[index] !== null && "errors" in listaErros[index]) {
        error.push(listaErros[index].errors);
      }

      return error;
    },
    setListaDeErrors(listaConceitos, listaErros) {
      for (const index in listaConceitos) {
        if (
          listaConceitos[index] !== null &&
          "errors" in listaConceitos[index]
        ) {
          listaErros[index] = {};
          listaErros[index]["errors"] = listaConceitos[index].errors;
        }
      }
    },
    async changePeriodoAvaliativo() {
      this.isReload = true;
      this.router_leave = null;
      const existeConceitosParaSalvar = this.getExisteConceitosPendenteParaSalvar(
        this.conceitos
      );
      if (existeConceitosParaSalvar) {
        this.dialog = true;
      } else {
        this.loadAtividades();
      }
    },
    async changeAtividade() {
      this.isReload = true;
      this.router_leave = null;
      const existeConceitosParaSalvar = this.getExisteConceitosPendenteParaSalvar(
        this.conceitos
      );
      if (existeConceitosParaSalvar) {
        this.dialog = true;
      } else {
        this.loadEnturmacaoConceito();
      }
    },
    resetListaDeConceitos(listaNotaModelo, listaConceitos) {
      listaNotaModelo.forEach((nota, index) => {
        listaConceitos[index] = null;
      });
    },
    getExisteConceitosPendenteParaSalvar(conceitos) {
      return conceitos.some((nota) => nota !== null);
    },
    onAddNotaNaLista({ index, nota }) {
      if (!nota) return;
      this.conceitos[index] = nota;
    },
    async handleSaveConceitos() {
      try {
        this.loadingSaveConceitos = true;
        // this.conceitos.aaletivo = this.aaletivo;
        // this.conceitos.cdinstruc = this.codinstruc;
        const response = await saveListaConceitosConceito({ data: this.conceitos,
        aaletivo: this.aaletivo,
        cdinstruc: this.codinstruc
        });
        const { message } = response.data;
        this.submitText = message;
        this.snackbar = true;
      } catch (error) {
        const { data } = error.response;
        const { message, result } = data;
        this.submitText = message;
        this.snackbar = true;

        this.setListaDeErrors(result.data, this.listaErros);
      } finally {
        this.periodoSelecionado =
          this.periodoSelecionado != this.periodoSelecionadoOld &&
          this.periodoSelecionadoOld != ""
            ? this.periodoSelecionadoOld
            : this.periodoSelecionado;

        this.distribuicaoSelecionada =
          this.distribuicaoSelecionada != this.distribuicaoSelecionadaOld &&
          this.distribuicaoSelecionadaOld != ""
            ? this.distribuicaoSelecionadaOld
            : this.distribuicaoSelecionada;

        this.loadingSaveConceitos = false;
        this.dialog = false;
        this.resetListaDeConceitos(this.enturmacaoConceito, this.conceitos);
      }
    },
    actionModal() {
      if (this.router_leave) {
        this.$router.push({ path: this.router_leave, params: {} });
      }
      if (this.isReload) {
        this.loadEnturmacaoConceito();
      }
    },
    handleModalSaveConceitos() {
      this.retornarParaATelaInicial = false;
      this.handleSaveConceitos();
    },
    handleCancelModalAvisoConceitos() {
      this.resetListaDeConceitos(this.enturmacaoConceito, this.conceitos);
      this.dialog = false;
      this.actionModal();
    },
    onClickInput(event, rowX) {
      this.linhaX = rowX;
      const items = document.querySelectorAll(
        `.select-conceito[data-index="${rowX}"]`
      );
      for (const [index, item] of items.entries()) {
        if (item.firstElementChild === event.target) {
          return (this.linhaY = index);
        }
      }
    },
    setFirstElementSelect() {
      const items = document.querySelectorAll(
        '.select-conceito[data-index="0"]'
      );
      if (items.length <= 0 || typeof items[0] === "undefined") {
        return;
      }

      this.linhaX = 0;
      this.linhaY = 0;

      let input = items[0].firstElementChild;
      input.focus();
    },
    onKeyUp(key) {
      let rowX = this.linhaX;
      let rowY = this.linhaY;
      let fim = this.enturmacaoConceito.length;

      switch (key.keyCode) {
        case 37:
          rowY--;
          fim = rowX + 1;
          break;
        case 38:
          rowX--;
          fim = 0;
          break;
        case 39:
          rowY++;
          fim = rowX + 1;
          break;
        case 40:
          rowX++;
          break;
        default:
          return;
      }

      let items = [];
      for (
        rowX;
        (rowX >= 0 && rowX <= fim) || (key.keyCode == 38 && rowX > fim);
        rowX = key.keyCode == 38 ? rowX - 1 : rowX + 1
      ) {
        items = document.querySelectorAll(
          `.select-conceito[data-index="${rowX}"]`
        );
        if (items.length > 0) {
          break;
        }
      }
      if (typeof items[rowY] === "undefined") {
        return;
      }

      this.linhaX = rowX;
      this.linhaY = rowY;

      let input = items[rowY].firstElementChild;
      input.focus();
    },
    montarPeriodoAvaliativo(periodo) {
      if (periodo.length <= 0) {
        return;
      }
      this.periodosAvaliativos = periodo;
      this.periodoSelecionado = periodo[0].value;
      this.loadAtividades(true);
    },
    montarAtividade(atividades) {
      this.atividadesDistribuidas = [];
      this.distribuicaoSelecionada = null;
      if (atividades.length <= 0) {
        return;
      }
      this.atividadesDistribuidas = atividades;
      if (!this.distribuicaoSelecionada) {
        this.distribuicaoSelecionada = atividades[0].value;
      }
    },
    async loadAtividades(firstLoad = false) {
      if (!this.periodoSelecionado) {
        this.msgError = "Período avaliativo não encontrado";
        return;
      }
      this.loading = true;

      if (!firstLoad) {
        this.$Progress.start();
      }
      this.msgError = "";
      this.atividadesDistribuidas = [];
      this.enturmacaoConceito = [];
      try {
        const formatedAtividade = await buscarAtividades({
          aaletivo: this.ano,
          cdturma: this.cdturma,
          cddiscipl: this.disciplina,
          cdpravadi: this.periodoSelecionado,
        });

        if (formatedAtividade.length <= 0) {
          this.msgError = "Nenhuma Atividade Distribuida encontrada!";
          return;
        }
        this.atividadesDistribuidas = formatedAtividade;
        this.distribuicaoSelecionada = this.atividadesDistribuidas[0].value;
        await this.loadEnturmacaoConceito(true);
      } finally {
        this.$Progress.finish();
        this.loading = false;
      }
    },
    async loadEnturmacaoConceito(firstLoad = false) {
      if (!this.distribuicaoSelecionada) {
        this.msgError = "Atividade avalitativa distribuida não encontrada!";
        return;
      }

      if (!firstLoad) {
        this.$Progress.start();
      }
      this.loading = true;
      this.msgError = "";
      this.enturmacaoConceito = [];
      this.tiposConceitos = [];
      this.todasAtividadesAlunos = [];
      try {
        const { cdtipesc, cdescola } = dadosUser();
        const { data } = await DiarioEscolarRepository.getEnturmacaoConceito({
          aaletivo: this.ano,
          cdtipesc,
          cdescola,
          cdturma: this.cdturma,
          cddiscipl: this.disciplina,
          cdpravadi: this.periodoSelecionado,
          identificadordistribuirconceit: this.distribuicaoSelecionada,
        });

        this.enturmacaoConceito = data.results.alunos;
        this.tiposConceitos = data.results.conceitos;
        this.periodoAberto = data.results.aberto;
        this.pdirecebelancamento = data.results.pdi_avaliado;

        // for (const aluno of this.enturmacaoConceito) {
        //   this.todasAtividadesAlunos.push(aluno.todasAtividades);
        // }

        this.enturmacaoConceito.forEach((aluno, key) => {
          this.todasAtividadesAlunos.push(aluno.todasAtividades);
          this.conceitos[key] = null;
          this.listaErros[key] = null;
        });

        // if(this.enturmacaoConceito.length > 0) { setTimeout(() => this.setFirstElementSelect(), 200); }
      } catch (error) {
        if (error.response) {
          this.msgError = error.response.data.errorMessage;
        }
        throw error;
      } finally {
        this.$Progress.finish();
        this.loading = false;
      }
    },
    onSubmittedSelect({ index, valor }) {
      const distribuido = this.enturmacaoConceito.some(
        (key) => key.distribuir_conceito.identificadorconceito > 0
      );
      const atividadeIndex = this.atividadesDistribuidas.findIndex(
        (key) => key.value === this.distribuicaoSelecionada
      );
      if (atividadeIndex >= 0) {
        this.atividadesDistribuidas[atividadeIndex].icon = distribuido
          ? "check"
          : "remove";
      }

      const alunoConceitoIndex = this.todasAtividadesAlunos[index].findIndex(
        (key) =>
          key.identificadordistribuirconceit == this.distribuicaoSelecionada
      );
      if (alunoConceitoIndex >= 0) {
        const conceito = this.tiposConceitos.find(
          (key) => key.identificadorconceito == valor
        );
        const valorConceito = conceito ? conceito.valorfinal : null;

        this.todasAtividadesAlunos[index][
          alunoConceitoIndex
        ].valorfinal = valorConceito;
      }
    },
    getDescricaoConceito(valor) {
      const valorFormated = parseFloat(valor.toFixed(1));
      const conceito = this.tiposConceitos.find(
        (key) =>
          key.valorfinal >= valorFormated && key.valorinicial <= valorFormated
      );
      return conceito ? conceito.valorconceito : "-";
    },
    totalPeriodo(index) {
      const atividadesFiltrada = this.enturmacaoConceito[
        index
      ].todasAtividades.filter(
        (key) => key.cdpravadi == this.periodoSelecionado
      );
      const valorMedia =
        atividadesFiltrada.reduce(
          (total, key) => total + key.valorfinal || 0,
          0
        ) / atividadesFiltrada.length;
      return this.getDescricaoConceito(valorMedia);
    },
    totalTodosPeriodos(index) {
      const todasAtividades = this.enturmacaoConceito[index].todasAtividades;
            //Apenas para o ano letivo de 2020, para Educação Infantil (semestres - 13, 14), não
            //houve primeiro semestre devido a pandemia da COVID-19, então o conceito final será o mesmo
            //conceito do segundo semestre
        if (this.ano === 2020 && (this.periodoSelecionado === '13' || this.periodoSelecionado === '14'))
        {
          const atividadesSegundoSemestre = todasAtividades.filter( (item) => item.cdpravadi === 14)
          const valorMedia =
          atividadesSegundoSemestre.reduce((total, key) => total + key.valorfinal, 0) / atividadesSegundoSemestre.length;
          return this.getDescricaoConceito(valorMedia);

        }
        else {
          const valorMedia =
          todasAtividades.reduce((total, key) => total + key.valorfinal, 0) / todasAtividades.length;
          return this.getDescricaoConceito(valorMedia);
        }
    },
  },
  computed: {
    exibirMsgError() {
      return this.periodosAvaliativos.length <= 0 || this.msgError;
    },
    montarOptionsConceitos() {
      return [
        { value: null, text: " -" },
        ...this.tiposConceitos.map((key) => ({
          value: key.identificadorconceito,
          text: key.valorconceito,
          title: key.descricaoconceito,
        })),
      ];
    },
    montarFormSubmit() {
      const { cdtipesc, cdescola, cdpessoal, cdmatric } = dadosUser();
      return {
        aaletivo: this.ano,
        cdtipesc,
        cdescola,
        cdturma: this.cdturma,
        cddiscipl: this.disciplina,
        cdpessoal,
        cdmatric,
        identificadordistribuirconceit: this.distribuicaoSelecionada,
      };
    },
  },
};
</script>

<style lang="scss" scope>
@media only screen and (max-width: 600px) {
  .v-btn {
    width: 100%;

  }
}

.lancar-conceito {
  .lancar-conceito-header-select {
    width: 300px;
  }

  .lancar-conceito-atividade-select {
    width: 100%;
  }

  .fixed {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1;

    th {
      position: -webkit-sticky;
      position: sticky;
      top: -2px;
      z-index: 2;
      background: white;
    }

    .header-detalhado {
      top: 67px !important;
    }
  }

  .table-overflow {
    overflow-y: auto;
    position: relative;
    max-height: 600px;

    &::-webkit-scrollbar {
      width: 7px;
      height: 7px;
    }

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.14);
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
    }
  }

  select option {
    width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .destaque-coluna {
    background: #cfd8dc;
  }

  .tamanho-colunas {
    width: 100px;
  }
}

@media only screen and (max-width: 500px) {
  .lancar-conceito-header-select,
  .lancar-conceito-atividade-select {
    width: 100%;
  }
}
</style>
